import { useState, useRef, useEffect } from "react";
import { ActiveBtn, CancelBtn } from "./components/Button";
import { macToProductKey } from "./api/productKey";

function App() {
  const [macId, setMacId] = useState("");
  const [generatedKeyId, setGeneratedKeyId] = useState("");

  // Create references for all the input fields
  const inputRefs = useRef([]);

  const handleGenerateKey = async () => {
    const pattern = /^[A-Fa-f0-9]+$/;
    console.log(pattern.test(macId));

    try {
      const AES_KEY = "1234567890ABCDEF"; // 16 bytes → AES-128
      const TWEAK = "EdgeAI-Series-A"; // optional (string or Uint8Array)

      const generatedKey = macToProductKey(macId, AES_KEY, { versionDigit: "0", tweak: TWEAK, rounds: 10 });
      // console.log("Product Key", generatedKey);
      const generatedKeyBuffer = generatedKey.substring(0, 4) + " - " + generatedKey.substring(4, 8) + " - " + generatedKey.substring(8, 12) + " - " + generatedKey.substring(12);
      setGeneratedKeyId(generatedKeyBuffer);
    } catch (err) {
      alert(err);
    }
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value;

    let newMacId = macId.replace(/[^A-Fa-f0-9]/g, "");

    // Update the macId by directly replacing the value at the specified index
    newMacId = newMacId.substring(0, index) + value + newMacId.substring(index + 1);

    setMacId(newMacId);

    // If the input field is filled, focus the next one
    if (newMacId.length === 12 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyPress = (e, index) => {
    const value = e.target.value;

    // Handle backspace
    if (e.key === "Backspace" && value === "" && inputRefs.current[index - 1]) {
      inputRefs.current[index - 1].focus();
    }

    // Allow moving to the next input when a character is typed
    if (value.length === 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  // on click clear reset all the data
  const handleClear = () => {
    setMacId("");
    setGeneratedKeyId("");
    // Clear all input fields using refs
    inputRefs.current.forEach((inputRef) => {
      if (inputRef) {
        inputRef.value = "";
      }
    });
  };

  // to reset product key on macId changes
  useEffect(() => {
    setGeneratedKeyId("");
  }, [macId]);

  return (
    <div className="App">
      <div className="header">iqlabs.io</div>

      <div className="container">
        <div className="heading">BLE Private Key Generator</div>

        {/* Input for the mac Id */}
        <div className="inputContainer">
          Mac Id:
          {[0, 2, 4, 6, 8, 10].map((i, groupIndex) => (
            <div key={i} style={{ display: "flex", gap: "4px" }}>
              <input type="text" className="input" maxLength="1" ref={(el) => (inputRefs.current[i] = el)} onChange={(e) => handleInputChange(e, i)} onKeyDown={(e) => handleKeyPress(e, i)} />
              <input
                type="text"
                className="input"
                maxLength="1"
                ref={(el) => (inputRefs.current[i + 1] = el)}
                onChange={(e) => handleInputChange(e, i + 1)}
                onKeyDown={(e) => handleKeyPress(e, i + 1)}
              />
              {groupIndex !== 5 && <span className="divide">:</span>}
            </div>
          ))}
        </div>

        <div className="buttonContainer">
          <ActiveBtn handleClick={handleGenerateKey} name={"Generate key"} />
          <CancelBtn handleClick={handleClear} name={"Clear"} />
        </div>

        {/* Product key */}
        {generatedKeyId && (
          <div className="keyContainer">
            <span style={{ color: "#a2a2a2" }}>Product Key: </span>
            {generatedKeyId}
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
